(function () {
  'use strict';
  var BASE = '/apps/catch-platform/v2';

  function feedback(element, ok, message) {
    if (!element) return;
    element.className = 'cu-feedback ' + (ok ? 'is-success' : 'is-error');
    element.textContent = message;
    element.setAttribute('role', ok ? 'status' : 'alert');
  }

  function errorMessage(data) {
    return (data && data.message) || 'Er ging iets mis. Probeer het opnieuw.';
  }

  // Inloggen loopt altijd via de officiele Shopify-klantaccounts; we bewaren alleen de bedoelde pagina (pad + query) als return_to.
  function loginUrl() { return '/customer_authentication/login?return_to=' + encodeURIComponent(location.pathname + location.search + location.hash); }
  function sessionBanner() {
    if (document.getElementById('cu-session-banner')) return;
    var host = document.querySelector('.cu-scope .cu-container'); if (!host) return;
    var box = document.createElement('div'); box.id = 'cu-session-banner'; box.className = 'cu-feedback is-error'; box.setAttribute('role', 'alert');
    box.innerHTML = window.CU_SESSION
      ? 'Je inlogsessie is in deze browser gewijzigd, bijvoorbeeld doordat je in een ander tabblad bent uitgelogd of met een ander account bent ingelogd. <a href="#" data-cu-reload>Vernieuw de pagina</a>.'
      : 'Je Shopify-sessie is verlopen of niet meer geldig. <a href="' + loginUrl().replace(/"/g, '&quot;') + '">Log opnieuw in</a>; je komt daarna terug op deze pagina.';
    box.addEventListener('click', function (ev) { if (ev.target.closest('[data-cu-reload]')) { ev.preventDefault(); location.reload(); } });
    host.insertBefore(box, host.firstChild);
  }

  // Onderscheidt: geen verbinding, tijdelijke serverfout en een echt verlopen sessie. Alleen dat laatste vraagt om opnieuw inloggen.
  async function request(path, options) {
    options = options || {};
    var method = String(options.method || 'GET').toUpperCase();
    var response, attempt = 0;
    while (true) {
      try { var init = Object.assign({ credentials: 'same-origin', cache: 'no-store' }, options); delete init.__cuRetried; response = await fetch(BASE + path, init); break; }
      catch (error) {
        if (method === 'GET' && attempt === 0) { attempt += 1; await new Promise(function (r) { setTimeout(r, 800); }); continue; }
        var offline = new Error('Geen verbinding met het beeldmakersplatform. Controleer je internetverbinding en probeer het opnieuw. Je bent niet uitgelogd.');
        offline.code = 'network_error'; offline.kind = 'network'; throw offline;
      }
    }
    var data = null;
    try { data = await response.json(); } catch (error) { data = null; }
    // De pagina is door Shopify met een ingelogde klant opgebouwd, maar de API kreeg geen klant mee: eenmalig opnieuw proberen
    // (kortstondige haper in de App Proxy) voordat er iets over de sessie wordt gemeld.
    if (data && data.error === 'not_logged_in' && window.CU_SESSION && !options.__cuRetried) {
      await new Promise(function (r) { setTimeout(r, 1200); });
      return request(path, Object.assign({}, options, { __cuRetried: true }));
    }
    if (!data || typeof data !== 'object') {
      var unavailable = new Error('Het beeldmakersplatform is tijdelijk niet bereikbaar (code ' + response.status + '). Je bent niet uitgelogd; probeer het over een minuut opnieuw.');
      unavailable.code = 'unavailable'; unavailable.kind = 'server'; unavailable.status = response.status; throw unavailable;
    }
    if (!response.ok || !data.ok) {
      var failure = new Error(errorMessage(data));
      failure.code = data.error; failure.status = response.status; failure.requestId = data.request_id;
      if (data.error === 'not_logged_in') { failure.kind = 'session'; failure.loginUrl = loginUrl(); failure.message = window.CU_SESSION ? 'Je inlogsessie is in deze browser gewijzigd. Vernieuw de pagina; je hoeft meestal niet opnieuw in te loggen.' : 'Je Shopify-sessie is verlopen. Log opnieuw in; je komt daarna terug op deze pagina.'; sessionBanner(); }
      else if ((data.error === 'not_staff' || data.error === 'not_artist') && window.CU_SESSION) { failure.message = errorMessage(data) + ' Ben je in een ander tabblad met een ander account ingelogd? Vernieuw dan de pagina.'; }
      else if (data.error === 'invalid_signature') { failure.kind = 'server'; failure.message = 'Je verzoek kon niet worden gecontroleerd. Vernieuw de pagina en probeer het opnieuw. Je bent niet uitgelogd.'; }
      else if (response.status >= 500) { failure.kind = 'server'; failure.message = errorMessage(data) + ' Je bent niet uitgelogd.' + (data.request_id ? ' (foutcode ' + String(data.request_id).slice(0, 8) + ')' : ''); }
      throw failure;
    }
    return data.data;
  }

  function bindForms() {
    document.querySelectorAll('form[data-catch-v2]').forEach(function (form) {
      form.addEventListener('submit', async function (event) {
        event.preventDefault();
        if (!form.reportValidity()) return;
        var button = form.querySelector('[type=submit]');
        var output = form.querySelector('[data-feedback]') || document.querySelector(form.dataset.feedback || '');
        var original = button ? button.textContent : '';
        if (button) { button.disabled = true; button.textContent = button.dataset.loading || 'Bezig...'; }
        try {
          var isJson = form.dataset.format === 'json';
          var body;
          var headers = {};
          if (isJson) {
            body = JSON.stringify(Object.fromEntries(new FormData(form).entries()));
            headers['Content-Type'] = 'application/json';
          } else body = new FormData(form);
          var data = await request(form.dataset.catchV2, { method: form.method || 'POST', headers: headers, body: body });
          feedback(output, true, form.dataset.success || 'Gelukt. De gegevens zijn opgeslagen.');
          form.dispatchEvent(new CustomEvent('catch:success', { detail: data }));
          if (form.dataset.reset === 'true') form.reset();
          if (form.dataset.reload === 'true') setTimeout(function () { location.reload(); }, 900);
        } catch (error) { feedback(output, false, error.message); }
        finally { if (button) { button.disabled = false; button.textContent = original; } }
      });
    });
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (char) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char]; });
  }

  // Ongelezen meldingen van Catch in de portalnavigatie. Alleen lezen; markeren gebeurt pas na openen.
  async function refreshUnread() {
    var badges = document.querySelectorAll('[data-cu-unread-badge]');
    if (!badges.length) return;
    try {
      var d = await request('/berichten/ongelezen');
      var n = d.unread_count || 0;
      badges.forEach(function (badge) { badge.textContent = n; badge.hidden = n === 0; badge.setAttribute('aria-label', n + (n === 1 ? ' ongelezen melding' : ' ongelezen meldingen')); });
    } catch (error) { /* teller is optioneel */ }
  }

  window.CatchV2 = { request: request, feedback: feedback, escapeHtml: escapeHtml, refreshUnread: refreshUnread, loginUrl: loginUrl };
  document.addEventListener('DOMContentLoaded', bindForms);
  document.addEventListener('DOMContentLoaded', refreshUnread);
}());
